import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_COMMENT_TYPE_URL } from '../../core.global';
import { BasicService } from '../../_base/services/basic.service';

@Injectable()
export class CommentTypeService extends BasicService{
    baseUrl:string = '';
    
    constructor(protected http: HttpClient){
        super(http);
        this.baseUrl = API_COMMENT_TYPE_URL;
    }
}